import { render, staticRenderFns } from "./categories_selector.vue?vue&type=template&id=5fafad30&"
import script from "./categories_selector.vue?vue&type=script&lang=js&"
export * from "./categories_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports